import { ASSISTER_FILTERS_TYPES,ASSISTER_FILTER_VALIDATION_TYPES } from '@constants/actionTypes/entityActionTypes';
import { fields } from '@constants/entity/entityConfig';

export const INITIAL_STATE = {
    [fields.CEC_FIRST_NAME] : { type : 'text',value : '', isVisible : false, message : 'Please Enter First Name' },
    [fields.CEC_LAST_NAME] : { type:'text', value : '', isVisible : false, message : 'Please Enter First Name' },
    [fields.ENTITY_SITE]: { type:'dropdown', value : '', values : [], isVisible : false, message : 'Please Enter First Name' },
    [fields.CEC_EMAIL] : { type:'text', value : '', isVisible : false, message : 'Please enter a valid email.' },
    [fields.CEC_LICENCE_NUMBER] : { type:'text', value : '', isVisible : false, message : 'Please Enter First Name' },
    

};

export default (state= INITIAL_STATE, action = {}) => {
    switch(action.type) {
        case ASSISTER_FILTERS_TYPES.INIT_ALL_FILTERS: {
            // Ohh... So innovative way of doing nothing. TODO: get rid of it one day
            return  { ...state };
        }
        case ASSISTER_FILTERS_TYPES.SET_FILTER_VALUE: {            
            const fieldName = action.newFilterValue.fieldName;
            const fieldValue = action.newFilterValue.fieldValue;
            const isVisible = action.newFilterValue.isVisible;
            return { ...state, [fieldName] : { ...state[fieldName] , value : fieldValue, isVisible : isVisible }
            };
        }
        case ASSISTER_FILTERS_TYPES.RESET_FILTER_VALUES: {
            return INITIAL_STATE;

        }
        case ASSISTER_FILTERS_TYPES.SET_ENTITY_SITE :{
            const a= [];
            action.value.forEach(s => {
                a.push ({ text : s.siteLocationName , value : s.id });
            });                         
            return { ...state, [fields.ENTITY_SITE] : { ...state[fields.ENTITY_SITE], values : a  } };
        }

        case ASSISTER_FILTER_VALIDATION_TYPES.SET_FILTER_FORM_STATE : {                  
            return { ...state, [fields.CEC_EMAIL] : { ...state[fields.CEC_EMAIL] , isVisible : action.filterValidationObj[fields.CEC_EMAIL].isVisible  } };
        }

        default:
            return state;
    }
};